import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDatepicker, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { PipesModule } from '../../pipes/pipes.module';
import { MonthlyDaterangePickerComponent } from './monthly-calendar/monthly-daterange-picker.component';
import { MonthlyDaterangeDayComponent } from './monthly-calendar/monthly-calendar-day/monthly-daterange-day.component';
import { RangeDatePipe } from './pipes/range-date.pipe';
import { MatIconModule } from '@angular/material/icon';
import { FtSwiperModule } from '../swiper/ft-swiper.module';

@NgModule({
    declarations: [
        MonthlyDaterangePickerComponent,
        MonthlyDaterangeDayComponent,
        RangeDatePipe,
    ],
    exports: [MonthlyDaterangePickerComponent],
    imports: [
        CommonModule,
        NgbDatepicker,
        FtSwiperModule,
        NgbDatepickerModule,
        PipesModule,
        MatIconModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MonthlyDaterangePickerModule {}
